<template>
  <div
    :class="['vch-popin-wrapper', `--${displayType}`, { '--open': showModal }]"
  >
    <div class="vch-popin-overlay" @click="closeModal" @keydown="closeModal" />
    <transition name="slide">
      <div
        v-show="showModal"
        @keyup.esc="closeModal"
        class="vch-popin"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="modalHeadingAriaLabel"
      >
        <div class="vch-popin__container container">
          <header class="vch-popin__header">
            <button
              class="vch-popin__close"
              :aria-label="closeAriaLabel"
              @click="closeModal"
            >
              <svg aria-hidden="true" width="40" height="40">
                <use href="/assets/sprite/icons.svg#close-overlay" />
              </svg>
            </button>
          </header>
          <div class="vch-popin__content">
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
const modalTypes = ['right-drawer', 'center', 'video'];

export default {
  name: 'vch-modal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    newsletterPopup: {
      type: Boolean,
      required: false,
    },
    busName: {
      type: String,
      required: false,
    },
    closeAriaLabel: {
      type: String,
      required: false,
    },
    displayType: {
      type: String,
      required: false,
      default: modalTypes[0],
      validator: (value) => {
        return !!value && modalTypes.includes(value);
      },
    },
    modalHeadingAriaLabel:{
      type: String,
      required: false,
      default: 'Modal heading',
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    open: function (opened) {
      this.showModal = opened;
      this.showModal ? this.setOverflow('hidden') : this.closeModal();
    },
  },
  mounted() {
    if (this.newsletterPopup == true) {
      this.showModal = true;
    }
    document.addEventListener('keyup', this.keyPressed);
  },
  created() {
    this.checkAndDisplayPopup();
  },
  methods: {
    checkAndDisplayPopup() {
      const popupShown = sessionStorage.getItem('navigationPopupShown');
      if (popupShown === 'true') {
        return;
      }

      let clickCount = sessionStorage.getItem('navigationClickCount') || 0;
      clickCount = parseInt(clickCount, 10);
      if (clickCount >= 2) {
        sessionStorage.setItem('navigationPopupShown', 'true');
        this.showModal = true;
      }
    },
    keyPressed(event) {
      if (event.keyCode === 27) {
        this.closeModal();
      }
      if (this.showModal && (event.key === 'Tab' || event.keyCode === 9)) {
        this.setFocus(event);
      }
    },
    closeModal() {
      document.cookie = "isLoggedIn=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.showModal = false;
      this.setOverflow('inherit');
      this.$emit('closed', true);
    },
    setOverflow(overflow) {
      return overflow === 'hidden'
        ? document.body.classList.add('modal-overlay')
        : document.body.classList.remove('modal-overlay');
    },
    setFocus() {
      const focusableElements = 'button, a, input, details, summary, ul, div';
      const modal = document.querySelector('.vch-popin__container');
      const allSelectableElements = [
        ...modal.querySelectorAll(focusableElements),
      ];
      const currentSelectedElement = document.activeElement;
      if (!allSelectableElements.includes(currentSelectedElement)) {
        const firstFocusableElement =
          modal.querySelectorAll(focusableElements)[0];
        firstFocusableElement.focus();
      }
    },
  },
  beforeDestroy() {
    eventBus.$off(`${this.busName}:open`);
    document.removeEventListener('keyup', this.keyPressed);
  },
};
</script>
<style lang="scss" src="./modal.scss"></style>
